// eslint-disable-next-line no-restricted-imports
import {push as historyPush, replace as historyReplace} from 'redux-first-history'

import {qs} from '@shared/helpers/queryString'

import {LocationState} from './interface'

interface Options {
    state?: LocationState
    query?: Record<string, string>
    resetScroll?: boolean
}

const resetPageScroll = () => {
    window.scrollTo(0, 0)
}

/** redux-first-history의 state parameter type이 any이므로 type check를 위해 wrapping한 push */
export const push = (url: string, options: Options = {}) => {
    options.resetScroll &&
        setTimeout(
            resetPageScroll,
            // 뒤로가기시 스크롤 복구를 위한 delay
            100,
        )
    return historyPush(qs.stringifyUrl({url, query: options.query ?? {}}), options.state)
}

/** redux-first-history의 state parameter type이 any이므로 type check를 위해 wrapping한 replace */
export const replace = (url: string, options: Options = {}) => {
    options.resetScroll && resetPageScroll()
    return historyReplace(qs.stringifyUrl({url, query: options.query ?? {}}), options.state)
}
